import { roundOff } from "utils";

const hexToRgba = (x) => {
  const hex = parse(x);
  const head = hex.slice(0, 6);
  const tail = hex.slice(6);
  const n = parseInt(head, 16);
  return [(n >> 16) & 0xff, (n >> 8) & 0xff, (n >> 0) & 0xff, getAlpha(tail)];
};

const parse = (x = "") => {
  const hex = x.replace(/^#/, "");
  const len = hex.length;
  return len === 3 || len === 4 ? repeat(hex) : hex;
};

const repeat = (x) =>
  x
    .split("")
    .map((y) => y + y)
    .join("");

const getAlpha = (x) => (x ? parseFloat(roundOff(parseInt(x, 16) / 0xff)) : 1);

const rgbaToHex = ([r = 0, g = 0, b = 0, a = 1] = []) => {
  const rgbN = (1 << 24) | (r << 16) | (g << 8) | b;
  const hex = rgbN.toString(16).slice(1);
  const alpha = (a * 255).toString(16).padStart(2, "0").slice(0, 2);
  return `#${hex}${alpha}`;
};

export const lightenDarken = (direction, color) => {
  const rgb = hexToRgba(color).slice(0, 3);

  const rgbAdjusted =
    direction >= 0
      ? rgb.map((x) => (1 - direction) * x + direction * 255)
      : rgb.map((x) => (1 + direction) * x);

  return rgbaToHex(rgbAdjusted).slice(0, 7);
};
